import { ExtendableError } from 'ts-error';

export class StorageException extends ExtendableError {}